/**
 * src/lib/constants/workflows.js — Domain-specific workflow enums.
 *
 * Centralizes enums that don't yet have a DB lookup table but are
 * referenced in multiple places. When a lookup table is added, consumers
 * should migrate to the corresponding hook from LookupContext.
 */

/**
 * Fallback work types — used when the DB lookup table is empty.
 * All files should reference this instead of inline arrays.
 */
export const FALLBACK_WORK_TYPES = ['Production', 'Installation', 'Design', 'Admin'];

/** Leave request types used in WorkDayView */
export const LEAVE_TYPES = ['vacation', 'sick', 'personal', 'other'];

/**
 * User roles — mirrors lib/roles.js ROLES array.
 * Duplicated here because lib/roles.js is a backend module that imports
 * Airtable dependencies and cannot be safely imported in frontend code.
 */
export const ROLE_OPTIONS = ['ceo', 'pmo', 'designer', 'production', 'shop', 'admin', 'sales', 'installer'];
